import * as React from "react"
import IconButton from "@mui/material/IconButton"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import { getColor } from "../../utils/Helpers"

const ITEM_HEIGHT = 48

export default function CustomMenu(props) {
  const { Icon, options, onChange, selectedOption, buttonStyles = {}, disabled = false, disabledOptions = [] } = props
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const handleClick = (event) => {
    event?.stopPropagation()
    setAnchorEl(event.currentTarget)
  }
  const handleClose = (e, v) => {
    e?.stopPropagation()
    console.log("onChange", v)
    onChange(v)
    setAnchorEl(null)
  }

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        disabled={disabled}
        // sx={{padding: 0}}
        sx={buttonStyles}
      >
        {Icon}
        {/* <Icon sx={{ height: "20px", width: "20px" }} /> */}
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onChange={onChange}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: "20ch",
            },
          },
        }}
      >
        {options?.map((option) => {
          const isSelected = option === selectedOption
          const isDisabled = disabledOptions.includes(option)
          let backgroundColor = getColor(option)

          return (
            <MenuItem
              key={option}
              className={`${isSelected && "active-menu"}`}
              value={option}
              onClick={(e) => handleClose(e, option)}
              style={{ paddingLeft: "10px" }}
              disabled={isDisabled}
            >
              <div
                className="circle-container"
                style={{ backgroundColor, marginRight: "8px" }}
              ></div>
              {option}
            </MenuItem>
          )
        })}
      </Menu>
    </div>
  )
}
